export default __webpack_public_path__ + "static/media/Hands_Sand.b277cb88.png";